export const MENU_ITEM_NAME = 'Menu Item Name';
export const RESTAURANT_ID  ='UP96mqCChsVzWKVzSSpK';
export const RESTAURANT_NAME = 'Curry King Test';